export const KEYCLOAK = {
  URL: import.meta.env.VITE_KEYCLOAK_URL as string,
  CLIENT_ID: import.meta.env.VITE_KEYCLOAK_CLIENT_ID as string,
  DANGEROUSLY_DISABLE_AUTH_LOCALLY:
    'true' ===
    (import.meta.env.VITE_DANGEROUSLY_DISABLE_AUTH_LOCALLY as string),
};
